import { Matrix4 } from 'three';

import { Truss, TrussEnvelope } from '@paragon/contract-library';
import { getEnvelopeSegmentFromEnvelope } from '@paragon/layout';

/**
 * Calculates and returns an array of matrices to position each ply of a truss. Each returned matrix is a distinct
 *   instance even if the truss has only one ply.
 *
 * Note that the produced matrices are in world coordinates, and are intended to absolutely position the ply. Use in
 *   conjunction with `matrixWorldAutoUpdate={false}` if you are using these matrices to position visuals that are
 *   descendants of `<LayoutModeVisuals />`.
 */
export function calculateTrussPlyMatrices(truss: Truss, trussEnvelope: TrussEnvelope, trussMatrix: Matrix4) {
  let instanceMatrix = trussMatrix.clone();
  if (truss.numberOfPlies === 1) return [instanceMatrix];

  const backLine = getEnvelopeSegmentFromEnvelope(trussEnvelope, 'Back');
  if (backLine == null) return [];

  const { x, y } = backLine.direction.rotateReverseQuarterTurn().toVector(trussEnvelope.thickness);
  const plyOffset = new Matrix4().makeTranslation(x, 0, -y);

  const result = [];

  for (let i = 0; i < truss.numberOfPlies; i++) {
    result.push(instanceMatrix);
    instanceMatrix = instanceMatrix.clone().premultiply(plyOffset);
  }

  return result;
}
